// Theme: solarized
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'solarized',
  name: 'SOLARIZED',
  tagline: 'SOLARIZED',
  description: 'Solarized classico em versao free BP leve com contraste controlado.',
  category: 'system-core',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#002B36', '#073642', '#2AA198', '#839496'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-solarized'
  },
  colorVars: {
    '--accent': '#2AA198',
    '--accent-foreground': '#002B36',
    '--background': '#002B36',
    '--border': '#113b46',
    '--card': '#073642',
    '--card-border-active': 'rgba(42, 161, 152, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#93A1A1',
    '--card-glow': 'rgba(42, 161, 152, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#002B36',
    '--foreground': '#93A1A1',
    '--hold-fill': '#2AA198',
    '--input': '#113b46',
    '--modal-bg': '#002B36',
    '--modal-border': '#113b46',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#113b46',
    '--muted-foreground': '#9EB0B0',
    '--nav-active': '#2AA198',
    '--nav-bg': '#073642',
    '--popover': '#073642',
    '--popover-foreground': '#93A1A1',
    '--primary': '#2AA198',
    '--primary-foreground': '#002B36',
    '--ring': '#2AA198',
    '--secondary': '#113b46',
    '--secondary-foreground': '#93A1A1',
    '--streak': '#2AA198',
    '--success': '#22c55e',
    '--success-foreground': '#002B36',
    '--xp': '#2AA198',
    '--xp-bg': '#073642'
  },
  resolvedVars: {
    '--accent': '#2AA198',
    '--accent-foreground': '#002B36',
    '--accent-foreground-hsl': '192 100% 11%',
    '--accent-foreground-oklch': 'from #002B36 l c h',
    '--accent-hsl': '175 59% 40%',
    '--accent-oklch': 'from #2AA198 l c h',
    '--background': '#002B36',
    '--background-hsl': '192 100% 11%',
    '--background-oklch': 'from #002B36 l c h',
    '--border': '#113b46',
    '--border-hsl': '192 61% 17%',
    '--border-oklch': 'from #113b46 l c h',
    '--border-w': '1px',
    '--card': '#073642',
    '--card-border-active': 'rgba(42, 161, 152, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#93A1A1',
    '--card-foreground-hsl': '180 7% 60%',
    '--card-foreground-oklch': 'from #93A1A1 l c h',
    '--card-glow': 'rgba(42, 161, 152, 0.03)',
    '--card-hsl': '192 81% 14%',
    '--card-oklch': 'from #073642 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#002B36',
    '--destructive-foreground-hsl': '192 100% 11%',
    '--destructive-foreground-oklch': 'from #002B36 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#93A1A1',
    '--foreground-hsl': '180 7% 60%',
    '--foreground-oklch': 'from #93A1A1 l c h',
    '--hold-fill': '#2AA198',
    '--hold-fill-hsl': '175 59% 40%',
    '--hold-fill-oklch': 'from #2AA198 l c h',
    '--input': '#113b46',
    '--input-hsl': '192 61% 17%',
    '--input-oklch': 'from #113b46 l c h',
    '--modal-bg': '#002B36',
    '--modal-bg-hsl': '192 100% 11%',
    '--modal-bg-oklch': 'from #002B36 l c h',
    '--modal-border': '#113b46',
    '--modal-border-hsl': '192 61% 17%',
    '--modal-border-oklch': 'from #113b46 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#113b46',
    '--muted-foreground': '#9EB0B0',
    '--muted-foreground-hsl': '180 10% 65%',
    '--muted-foreground-oklch': 'from #9EB0B0 l c h',
    '--muted-hsl': '192 61% 17%',
    '--muted-oklch': 'from #113b46 l c h',
    '--nav-active': '#2AA198',
    '--nav-active-hsl': '175 59% 40%',
    '--nav-active-oklch': 'from #2AA198 l c h',
    '--nav-bg': '#073642',
    '--nav-bg-hsl': '192 81% 14%',
    '--nav-bg-oklch': 'from #073642 l c h',
    '--popover': '#073642',
    '--popover-foreground': '#93A1A1',
    '--popover-foreground-hsl': '180 7% 60%',
    '--popover-foreground-oklch': 'from #93A1A1 l c h',
    '--popover-hsl': '192 81% 14%',
    '--popover-oklch': 'from #073642 l c h',
    '--primary': '#2AA198',
    '--primary-foreground': '#002B36',
    '--primary-foreground-hsl': '192 100% 11%',
    '--primary-foreground-oklch': 'from #002B36 l c h',
    '--primary-hsl': '175 59% 40%',
    '--primary-oklch': 'from #2AA198 l c h',
    '--radius': '16px',
    '--ring': '#2AA198',
    '--ring-hsl': '175 59% 40%',
    '--ring-oklch': 'from #2AA198 l c h',
    '--secondary': '#113b46',
    '--secondary-foreground': '#93A1A1',
    '--secondary-foreground-hsl': '180 7% 60%',
    '--secondary-foreground-oklch': 'from #93A1A1 l c h',
    '--secondary-hsl': '192 61% 17%',
    '--secondary-oklch': 'from #113b46 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#2AA198',
    '--streak-hsl': '175 59% 40%',
    '--streak-oklch': 'from #2AA198 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#002B36',
    '--success-foreground-hsl': '192 100% 11%',
    '--success-foreground-oklch': 'from #002B36 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(175 59% 40% / 0.15)',
    '--xp': '#2AA198',
    '--xp-bg': '#073642',
    '--xp-bg-hsl': '192 81% 14%',
    '--xp-bg-oklch': 'from #073642 l c h',
    '--xp-hsl': '175 59% 40%',
    '--xp-oklch': 'from #2AA198 l c h'
  }
}
